import {
    FETCH_COMPLIANCE_ASSESSMENTS,
    FETCH_COMPLIANCE_ASSESSMENTS_FAIL,
    FETCH_COMPLIANCE_ASSESSMENTS_SUCCESS,
    FETCH_COMPLIANCE_STANDARDS,
    FETCH_COMPLIANCE_STANDARDS_FAIL,
    FETCH_COMPLIANCE_STANDARDS_SUCCESS,
    PUT_COMPLIANCE_ASSESSMENT, PUT_COMPLIANCE_ASSESSMENT_FAIL, PUT_COMPLIANCE_ASSESSMENT_SUCCESS

} from "../constants/ActionTypes";

/*  jfd*******************************
 *   fetching a compliance standard
     ********************************** */

export const fetchComplianceStandardsAction = (data) => {
    return {
        type: FETCH_COMPLIANCE_STANDARDS,
        payload: data
    };
};

export const fetchComplianceStandardsSuccess = (data) => {
    return {
        type: FETCH_COMPLIANCE_STANDARDS_SUCCESS,
        payload: data
    };
};

export const fetchComplianceStandardsFail = (data) => {
    return {
        type: FETCH_COMPLIANCE_STANDARDS_FAIL,
        payload: data
    };
};

/*  jfd*******************************
 *   fetching assessment records for a given standard
     ********************************** */

export const fetchComplianceAssessmentsAction = (data) => {
    return {
        type: FETCH_COMPLIANCE_ASSESSMENTS,
        payload: data
    };
};

export const fetchComplianceAssessmentsSuccess = (data) => {
    return {
        type: FETCH_COMPLIANCE_ASSESSMENTS_SUCCESS,
        payload: data
    };
};

export const fetchComplianceAssessmentsFail = (data) => {
    return {
        type: FETCH_COMPLIANCE_ASSESSMENTS_FAIL,
        payload: data
    };
};

/*  jfd*******************************
 *   adding a new compliance record
     ********************************** */

export const putComplianceAssessmentAction = (data) => {
    return {
        type: PUT_COMPLIANCE_ASSESSMENT,
        payload: data
    };
};

export const putComplianceAssessmentSuccess = (data) => {
    return {
        type: PUT_COMPLIANCE_ASSESSMENT_SUCCESS,
        payload: data
    };
};

export const putComplianceAssessmentFail = (data) => {
    return {
        type: PUT_COMPLIANCE_ASSESSMENT_FAIL,
        payload: data
    };
};